<template>
    <a-select
      v-model:value="value"
      show-search
      style="width: 100%"
      :allowClear="true"
      :default-active-first-option="false"
      :show-arrow="false"
      :filter-option="false"
      :not-found-content="null"
      :options="suggestionData"
      @search="search"
      @change="onChange"
      :mode="mode"
      :disabled="disabled"
    ></a-select>
</template>
<script lang='ts' setup>
import { ref, defineProps, defineEmits, computed, onMounted, watch } from 'vue';
import request from '@/utils/request'

let _searchDebounce: any = null

const suggestionData: any = ref([])

const props = defineProps({
  modelValue: {
    type: [String, Array],
  },
  name: {
    type: String,
  },
  isStrict: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  mode: {
    type: String,
    default: '',
  },
})

const emits = defineEmits(['update:modelValue', 'update:name', 'changeValues'])

const value: any = computed({
  set(val) {
    emits('update:modelValue', val)
  },
  get() {
    return props.modelValue
  },
})
onMounted(() => {
  search('')
})
watch(props, (newVal) => {
  console.log('watch', newVal.modelValue);
  
  if (newVal.modelValue) {
    let name = newVal.name ? newVal.name.split(']')[1] : ''
    if (!suggestionData.value.find(v=>v.value==newVal.modelValue)) {
      request.get(`/api/in/kol/cpe/admin/star_user`, {
        username: name,
        pageSize: 500,
        pageNum: 1,
        isCpe: 1,
      }).then((rsp:any) => {
        suggestionData.value = []
        for (let v of rsp.data.list) {
          suggestionData.value.push({
            label: v.username,
            value: v.id
          })
        }
      })
    }
  }
})

const search = (name) => {
  clearTimeout(_searchDebounce)
  _searchDebounce =  setTimeout(() => {
      try {
        request.get(`/api/in/kol/cpe/admin/star_user`, {
          username: name,
          pageSize: 500,
          pageNum: 1,
          isCpe: 1,
        }).then((rsp:any) => {
          suggestionData.value = []
          for (let v of rsp.data.list) {
            suggestionData.value.push({
              label: v.username,
              value: v.id
            })
          }
        })
      } catch(err){
        console.log('err')
      }
    }, 600)
  
}

const onChange = (item, options) => {
  console.log('onChange',item, options);
  if (item) {
    emits('changeValues', {blogger_name: options.label})
    emits('update:modelValue',item)
  }
}
</script>
<style lang='scss' scoped>

</style>